import { UpdateTeethStateReq_ToothUpdate } from '@/shared/api/protocol-ts/api/core/svc_report_pb';
import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { PendingChange } from '@/shared/config';

export const getTargetByReportType = (
  change: PendingChange,
  reportType?: ReportType,
): UpdateTeethStateReq_ToothUpdate['Target'] => {
  const usesToothID =
    reportType === ReportType.ReportType_CBCT_GP ||
    reportType === ReportType.ReportType_Pano_GP;

  if (usesToothID) {
    return {
      case: 'ToothID',
      value: change.tooth.toothID,
    };
  }

  return {
    case: 'ToothDetectionID',
    value: change.tooth.detectionID,
  };
};
